const defaultOptions = {
  locale: "en-US",
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  signDisplay: "auto",
}

export default class NumberFormat {
  static currency(amount = 0, options = {}) {
    const { locale, ...restConfig } = { ...defaultOptions, ...options }
		const format = new Intl.NumberFormat(locale, restConfig)
    if (isNaN(amount)) return format.format(0)
		return format.format(amount)
  }
}